import React from 'react';
import { useSelector } from 'react-redux';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import { Navigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const Maintenance = () => {
  const userProfileWidgets = useSelector(state => state.userProfileWidgets);

  return (
    <div>
      {IsWidgetAccessible(userProfileWidgets, 'TELEMETRY_TAB') ? (
        <Navigate to="/maintenance/telemetry" />
      ) : IsWidgetAccessible(userProfileWidgets, 'PARTS_TAB') ? (
        <Navigate to="/maintenance/parts" />
      ) : IsWidgetAccessible(userProfileWidgets, 'SERVICE_TAB') ? (
        <Navigate to="/maintenance/service" />
      ) : IsWidgetAccessible(userProfileWidgets, 'TAGOUT_TAB') ? (
        <Navigate to="/maintenance/tagout-history" />
      ) : (
        ''
      )}
      <span>
        <FormattedMessage
          id="maintenance.tagout.NoAccess"
          defaultMessage="You do not have access to maintainence. Please contact your administrator."
        />
      </span>
    </div>
  );
};

export default Maintenance;
